import Box from "@mui/material/Box";
import { croppedImageSx } from "./layerCrop";

const cropBoxResetSx = {
  maxWidth: "none",
  maxHeight: "none",
};

export const CroppedLayerImage = ({
  src,
  alt = "",
  crop,
  objectFit = "fill",
  opacity = 1,
  markForLiveCrop = false,
}) => {
  const cropSx = croppedImageSx({ crop });

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <Box
        data-template-crop-img={markForLiveCrop ? "" : undefined}
        sx={{
          ...cropSx,
          ...cropBoxResetSx,
        }}
      >
        <Box
          component="img"
          src={src}
          alt={alt}
          draggable={false}
          sx={{
            width: "100%",
            height: "100%",
            objectFit,
            opacity,
            display: "block",
            pointerEvents: "none",
            userSelect: "none",
            ...cropBoxResetSx,
          }}
        />
      </Box>
    </Box>
  );
};
